import type { BrandJson } from "@coras-io/brand-tokens";
import {
  DEFAULT_CURRENCIES,
  DEFAULT_LOCALES,
  type SiteConfig,
} from "../../src/types";
import { MILES_AND_MORE } from "../../src/loyalty/miles-and-more";
import brandConfig from "./brand.json";

export const brand = brandConfig as BrandJson;

export const site: SiteConfig = {
  distributorId: "fd740414-2c6e-4741-bec0-57ca4ab04108",
  title: "SWISS",
  description: "Book tickets to West End Shows, Concerts and more",
  locale: "en-GB",
  currency: "CHF",
  locales: DEFAULT_LOCALES,
  currencies: DEFAULT_CURRENCIES,
  favicons: ["favicon.png"],
  logo: "/assets/images/logo.svg",
  domain: "swiss.coras.io",
  detectLocale: true,
  detectCurrency: true,
  linkedTravelNotice: {
    company: "Swiss International Air Lines Ltd",
    companyPossessive: "Swiss International Air Lines Ltd's",
    insolvencyProtectionUrl: {
      default:
        "https://www.swiss.com/de/en/book-and-manage/conditions/travel-package-conditions",
      "de-DE":
        "https://www.swiss.com/de/de/book-and-manage/conditions/travel-package-conditions",
    },
  },
  loyalty: MILES_AND_MORE,
};
